import { ChangeEvent } from 'react';
import { Stack, Typography } from '@mui/material';
import { Switch } from '@engyalo/design-system';
import { useTranslation } from 'react-i18next';
import yaloLogo from 'assets/icons/yalo-logo.svg';
import { IAppHeaderProps } from './types.d';
import { CustomTypography, HeaderWrapper, LabelWrapper, StatusIcon, SwitchWrapper } from './style';

const AppHeader = ({ sectionTitle, isUserOnline, handleUserStatus }: IAppHeaderProps) => {
  const { t } = useTranslation();
  const statusIconClass = isUserOnline ? 'online' : 'offline';
  const status = isUserOnline ? t('available') : t('offline');
  const handleSwitchChange = (event: ChangeEvent<HTMLInputElement>) => {
    handleUserStatus(event.target.checked);
  };

  return (
    <HeaderWrapper data-testid="mobileAppHeader">
      <Stack direction="row" gap={1} alignItems="center">
        <img src={yaloLogo} alt="Yalo Logo" />
        <Typography variant="h3">{sectionTitle}</Typography>
      </Stack>
      <SwitchWrapper
        control={<Switch checked={isUserOnline} onChange={handleSwitchChange} />}
        label={
          <LabelWrapper>
            <StatusIcon className={statusIconClass} />
            <CustomTypography variant="body2">{status}</CustomTypography>
          </LabelWrapper>
        }
        labelPlacement="start"
      />
    </HeaderWrapper>
  );
};

export default AppHeader;
